module.exports = __webpack_public_path__ + "static/media/advanced.26ec0dec.svg";